import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
  private modals: any[] = [];

  add(modal: any) {
    this.modals.push(modal);
  }

  remove(id: string) {
    const modalToRemove = this.modals.find(m => m.id === id);
    this.modals = this.modals.filter(m => m !== modalToRemove);
  }

  open(id: string) {
    const modal = this.modals.find(m => m.id === id);
    if (modal) {
      modal.open();
    }
  }

  close(id: string) {
    const modal = this.modals.find(m => m.id === id);
    modal.close();
  }
}
